
import Vue from "vue";
import store from "@/store";
import LINK from "@/utils/link";
import AppLoading from "@/components/UI/AppLoading.vue";
import { convertToPersian, separateDigits } from "@/utils/string";
import AppWarning from "@/components/UI/AppWarning.vue";

export default Vue.extend({
  name: "AdminAdminsList",
  components: { AppLoading, AppWarning },
  data() {
    return {
      userId: "",

      dialog: false,
      editDialog: false,

      LINK: LINK,
      defaultAvatar: require("@/assets/img/default-user.png"),

      HeadersTable: [
        "ردیف",
        "نام و نام خانوادگی",
        "موبایل",
        "موجودی",
        "پروفایل",
        "شهر",
      ],
    };
  },
  computed: {
    adminsList(): any[] {
      return store.state.admin.adminsList;
    },
  },
  methods: {
    separateDigits,
    convertToPersian,
  },
  created(): void {
    if (!store.state.admin.adminsList.length) {
      store.state.app.pageLoading = true;
      store.dispatch("admin/getAdminsList");
    }
  },
});
